// extracted by mini-css-extract-plugin
export default {"searchboxContainer":"RecordsHeader-module__searchboxContainer___vCT2D","searchbox":"RecordsHeader-module__searchbox___ONMn3"};